import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../core/store/store";
import { LoadingComponent } from "../../../../../core/components/LoadingComponent";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ButtonBack } from "../../../../../core/components/CustomButton";
import { Column } from "../../../../../core/components/Column";
import { onLogout } from "../../../../auth/presentation/store/auth/AuthThunk";

export const LayoutOnboarding = () => {
  const { isLoading } = useSelector((state: RootState) => state.auth);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const previousHtmlOverflowY = html.style.overflowY;
    const previousBodyOverflowY = body.style.overflowY;

    html.style.overflowY = "auto";
    body.style.overflowY = "auto";

    return () => {
      html.style.overflowY = previousHtmlOverflowY;
      body.style.overflowY = previousBodyOverflowY;
    };
  }, []);

  const onBack = () => {
    if (location.pathname !== "/") {
      navigate(-1);
      return;
    }
    dispatch(
      onLogout()
    );
    dispatch({ type: "DESTROY_SESSION" });
  };

  return (
    <LoadingComponent isLoading={isLoading}>
      <main className="bg-gradient-with-image h-screen w-full overflow-y-auto overflow-x-hidden scrollbar-hide">
        <Column
          className="relative min-h-screen w-full max-md:gap-10 pb-8"
          mainAxisAlignment="maxmdstart"
        >
        <ButtonBack onClick={onBack} className="md:absolute max-md:pt-6 max-md:pl-5 md:top-12 md:left-10 z-10">
          Go Back
        </ButtonBack>
        <img
          className="pointer-events-none absolute max-md:hidden md:top-10 md:right-10 w-44 select-none"
          src="/hookup4u-Logo-BP.png"
          width={250}
          height={96}
          alt="unjabbed-logo"
        />
        <img
          className="pointer-events-none absolute max-md:hidden md:bottom-0 md:left-0 -z-[1] select-none"
          src="/vector-line.png"
          width={795}
          height={860}
          alt="decorative-vector-line"
        />
        <Outlet />
        </Column>
      </main>
    </LoadingComponent>
  )
};
